export default __webpack_public_path__ + "static/pietobar-c9a2a369b7d67d37315877e459294d71.gif";